import misRutas from 'vue-routes-generator'
import GestionEGMComponent from './app'
export default {
	install: Vue => {
		misRutas.route('/main').child('gestion-egm', {
			name: 'Gestión de EGM',
			component: GestionEGMComponent
		})
	}
}



// WEBPACK FOOTER //
// ./src/modulos/gestion-egm/vue/index.js